import { z } from 'zod';
import { SafeStringSchema } from '../../../types/CommonSchemas';

export const AstraSubscriptionSchema = z.object({
    id: SafeStringSchema,
    timeDeactivation: z.iso.datetime(),
    isRotten: z.boolean(),
    daysLeft: z.number(),
    code: SafeStringSchema,
    unbindAvailable: z.boolean(),
    unbindAvailableTime: z.iso.datetime(),
    modemName: SafeStringSchema,
    modemId: SafeStringSchema
});

export type AstraSubscriptionData = z.infer<typeof AstraSubscriptionSchema>;

export const AstraSubscriptionListSchema = z.array(AstraSubscriptionSchema);

export type AstraSubscriptionDataList = z.infer<typeof AstraSubscriptionListSchema>;

export const AstraUserSubscriptionSchema = z.object({
    id: SafeStringSchema,
    timeDeactivation: z.iso.datetime(),
    isRotten: z.boolean(),
    daysLeft: z.number(),
    code: SafeStringSchema,
    unbindAvailable: z.boolean(),
    unbindAvailableTime: z.iso.datetime()
});

export type AstraUserSubscriptionData = z.infer<typeof AstraUserSubscriptionSchema>;

export const AstraModemSubscriptionSchema = AstraUserSubscriptionSchema.extend({
    modemName: z.string(),
    modemId: z.string()
});

export type AstraModemSubscriptionData = z.infer<typeof AstraModemSubscriptionSchema>;

export const AstraModemSubscriptionListSchema = z.array(AstraModemSubscriptionSchema);

export type AstraModemSubscriptionDataList = z.infer<typeof AstraModemSubscriptionListSchema>;

export const SubscriptionPlanSchema = z.object({
    id: SafeStringSchema,
    name: SafeStringSchema,
    price: z.number(),
    daysCount: z.number()
});

export type SubscriptionPlanData = z.infer<typeof SubscriptionPlanSchema>;

export const SubscriptionPlanListSchema = z.array(SubscriptionPlanSchema);

export type SubscriptionPlanDataList = z.infer<typeof SubscriptionPlanListSchema>;
